import { ReactNode } from 'react';

interface EmptyStateProps {
  icon: string;
  title: string;
  description: string;
  action?: ReactNode;
}

export const EmptyState = ({ icon, title, description, action }: EmptyStateProps) => {
  return (
    <div className="text-center py-8">
      <div className="text-gray-400 text-4xl mb-4">{icon}</div>
      <p className="text-gray-600 font-medium">{title}</p>
      <p className="text-sm text-gray-400 mt-2">{description}</p>
      {action && <div className="mt-4 flex justify-center">{action}</div>}
    </div>
  );
};
